<!--
 * @Description:
 * @Author: 长老
 * @Date: 2019-07-23 16:06:51
 * @LastEditTime: 2020-06-30 17:01:37
 * @LastEditors: yaoyc
 -->
<template>
  <div id="app">
    <keep-alive :include="include">
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
import { YjPerformance } from '@yunji/report'
import YunJi from '@/common/js/YunJi.js'
import { uuid } from '@/common/js/Util.js'

export default {
  data() {
    return {
      appCont: YunJi.getUrlParams('appCont') || 0, // 客户端标识 0-H5，1-卖家版，2-买家版
      shopId: YunJi.getUrlParams('shopId'), // 店铺id
      include: ['shareProfitsHome', 'shareProfitsDetail', 'clockInActivityList']
    }
  },
  mounted() {
    YunJi.getUserAgent()
    this.initThinkingReport()
    this.reportPerformance()
  },
  methods: {
    /*
    * 数据上报
    */
    initThinkingReport() {
      let appId = ''
      if (
        globalConfig.linkPath.startsWith('v.yunji')
        || globalConfig.linkPath.startsWith('t-do-dev.yunji')
        || globalConfig.linkPath.startsWith('special-al-dev-tmp.yunji')
        || globalConfig.linkPath.startsWith('special-al-dev.yunji')
        || globalConfig.linkPath.startsWith('lb-tx.yunji')
      ) {
        // 测试
        if (this.appCont == 0) {
          appId = '587f69909c9749ac8f98562527e948a2'
        } else if (this.appCont == 1) {
          appId = '78cbafbbb0a94edb85126bf7350c198e'
        } else if (this.appCont == 2) {
          appId = '2cf61875c9f9487c968e9da49102b71b'
        } else if (this.appCont == 7) {
          appId = '5eca5fe77a054873814b6a178b04d007'
        }
      } else {
        // 正式
        // eslint-disable-next-line no-lonely-if
        if (this.appCont == 0) {
          appId = 'ba036c847ebf492ab5dcef1de530b44e'
        } else if (this.appCont == 1) {
          appId = '48df4d00dffb488889293dc20521e31d'
        } else if (this.appCont == 2) {
          appId = 'f0edd6e68c6949da94a4a8ae3678b0f7'
        } else if (this.appCont == 7) {
          appId = '51040442586f4223b5fb075d4ffd5f74'
        }
      }
      (function (param) {
        let p = param.sdkUrl,
          n = param.name,
          w = window,
          d = document,
          s = 'script',
          x = null,
          y = null
        w.ThinkingDataAnalyticalTool = n
        w[n] = w[n]
          || function (a) {
            return function () {
              (w[n]._q = w[n]._q || []).push([a, arguments])
            }
          }
        const methods = [
          'track',
          'quick',
          'login',
          'logout',
          'trackLink',
          'userSet',
          'userSetOnce',
          'userAdd',
          'userDel',
          'setPageProperty'
        ]
        for (let i = 0; i < methods.length; i++) {
          w[n][methods[i]] = w[n].call(null, methods[i])
        }
        if (!w[n]._t) {
          (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0])
          x.async = 1
          x.src = p
          y.parentNode.insertBefore(x, y)
          w[n].param = param
        }
      }({
        appId: appId, // 系统分配的APPID
        name: 'thinkingReport', // 全局的调用变量名，可以任意设置，后续的调用使用该名称即可
        sdkUrl: 'https://static.yunjiglobal.com/qnUpload/frontend/js/thinkingdata_newVersion1.js', // 统计脚本URL
        // sdkUrl: 'https://static.yunjiglobal.com/qnUpload/frontend/js/thinkingdata_1.0.5.js', // 统计脚本URL
        serverUrl: `//${globalConfig.initThinkingReport}/sync_js`,
        send_method: 'ajax',
        showLog: false // true: 控制台打印数据上报
      }))

      if (this.appCont == 0) {
        // H5传的是consumer_id
        const consumer_id = YunJi.getCookie('burial_point_cid')
        const union_id = YunJi.getCookie('burial_point_wx_id')
        if (consumer_id) {
          thinkingReport.setPageProperty({ consumer_id: consumer_id })
        }
  
        if (union_id) {
          thinkingReport.login(union_id)
        } else {
          thinkingReport.logout()
        }
        thinkingReport.setPageProperty({
          link_shop_id: YunJi.getUrlParams('shopId')
        })
      } else if (this.appCont == 1) {
        // 卖家版传的是shopId
        if (YunJi.appUA.shop_id && YunJi.appUA.shop_id !== 'null') {
          thinkingReport.login(YunJi.appUA.shop_id)
        } else if (YunJi.getUrlParams('shopId')) {
          thinkingReport.login(YunJi.getUrlParams('shopId'))
        } else {
          thinkingReport.logout()
        }
        thinkingReport.setPageProperty({
          '#app_version': YunJi.appUA.appVersion
        })
        thinkingReport.setPageProperty({ '#os': YunJi.appUA.appClient })
      } else if (this.appCont == 2) {
        // vip传的是user_id  也就是 consumer_id
        if (YunJi.appUA.user_id && YunJi.appUA.user_id !== 'null') {
          thinkingReport.login(YunJi.appUA.user_id)
        } else {
          thinkingReport.logout()
        }
        thinkingReport.setPageProperty({
          '#app_version': YunJi.appUA.appVersion
        })
        thinkingReport.setPageProperty({ '#os': YunJi.appUA.appClient })
      } else if (this.appCont == 7) {
        // vip传的是user_id  也就是 consumer_id
        // H5传的是consumer_id
        const ticket = YunJi.getUrlParams('ticket')
        // 优化埋点，不管有没有登录都带distinct_id，登陆了才使用consumerId login
        if (!localStorage.getItem('uuid')) {
          localStorage.setItem('uuid', uuid())
        }
        thinkingReport.setPageProperty({ distinct_id: `null${localStorage.getItem('uuid').replace(/-/g, '')}` })
        if (ticket != 'ticket|') {
          const consumerId = ticket.split('_')[1]
          thinkingReport.login(consumerId)
          thinkingReport.setPageProperty({ consumer_id: consumerId })
        } else {
          thinkingReport.logout()
        }
      }
    },
    reportPerformance() {
      YjPerformance()
    }
  }
}
</script>
<style lang="stylus">
</style>
